module.exports = __webpack_public_path__ + "img/file-icon.b8db54fd.svg";